import {
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
  Button,
  Table,
  Tab,
  Badge,
  Nav,
  Dropdown,
} from "react-bootstrap";

import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import {
  FaBook,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaRegCircleUser,
} from "react-icons/fa6";
import { BsCalendar, BsThreeDotsVertical } from "react-icons/bs";
import {
  FaUser,
  FaCalendarAlt,
  FaChartBar,
  FaDollarSign,
  FaBell,
} from "react-icons/fa";
import { Bar, BarChart, Tooltip as RechartTooltip, XAxis } from "recharts";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import "./DashboardHome.css"; //1/ ملف CSS مخصص
import { useEffect, useState } from "react";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";
import {
  baseURL,
  CONTACTMESSAGE,
  LESSONS,
  REVENUE,
  STUDENTQUEREY,
  TASKS,
  USERACADEMACSTATUSE,
  ACADEMACYEARSDASHBORD,
  STYDYMONTH,
  LESSONSDASHBORD,
  EXAMDASHBORD,
  CREATEQUESTIONDASHBORD,
  ANNOUNCEMNTS,
  USERDASHBORD,
  TASKDHASHBORD,
} from "../../../API/API";
import {
  faBell,
  faCalendarAlt,
  faClock,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import {
  faCakeCandles,
  faCalendarDay,
} from "@fortawesome/free-solid-svg-icons";

export default function DashboardHome() {
  const [userAcademec, setUserAcademac] = useState([]);
  const [totaluser, setTotalUser] = useState(0);
  const [totalRevenue, settotalRevenue] = useState(0);
  const [totalLessons, setTotalLessons] = useState(0);
  const [totalTask, setTotalTask] = useState(0);
  const [totalAcademicYears, setTotalAcademicYears] = useState(0);
  const [totalChapters, setTotalChapters] = useState(0);
  const [totalExams, setTotalExams] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [totalAds, setTotalAds] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);
  const axiosPrivate = useAxiosPrivate();
  const [DataFinance, setDataFinance] = useState([]);
  const [DataLesson, setDataLesson] = useState([]);
  const [messages, setMessages] = useState([]);
  const [key, setKey] = useState("students");
  const [contactMessage, setcontaMessage] = useState([]);
  const { refreshKey } = useDataRefresh();
  const [Task, setTask] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showAll, setShowAll] = useState(false);
  const COLORS = ["#FF6384", "#36A2EB", "#9966FF", "#4CAF50"];

  const taskDays = Task.map((task) => new Date(task.task_date).getDate());
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const startDayOfWeek = new Date(currentYear, currentMonth, 1).getDay();

  const getMonthName = (monthIndex) =>
    new Date(2025, monthIndex).toLocaleString("ar-EG", { month: "long" });

  const generateCalendarRows = () => {
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    const rows = [];
    let currentWeek = new Array(startDayOfWeek).fill(null);

    for (let i = 0; i < days.length; i++) {
      currentWeek.push(days[i]);
      if (currentWeek.length === 7) {
        rows.push(currentWeek);
        currentWeek = [];
      }
    }

    if (currentWeek.length) {
      while (currentWeek.length < 7) currentWeek.push(null);
      rows.push(currentWeek);
    }

    return rows;
  };

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
  };

  //1/ Number Of User
  useEffect(() => {
    async function HandelDataUser() {
      try {
        const response = await axiosPrivate.get(
          `${baseURL}/${USERACADEMACSTATUSE}/`
        );
        console.log("User Stats:", response.data);
        setUserAcademac(response.data?.byAcademicYear || []);
        setTotalUser(response.data?.totalUsers || 0);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }

    HandelDataUser();
  }, [axiosPrivate]);

  //1/ Number Of Finance
  useEffect(() => {
    async function handleDataFinance() {
      try {
        const response = await axiosPrivate.get(`${baseURL}/${REVENUE}/`);
        console.log("Revenue Stats:", response.data);
        setDataFinance(response.data?.byAcademicYear || []);
        settotalRevenue(response.data?.totalRevenue ?? 0);
      } catch (err) {
        console.error("Error fetching revenue data:", err);
      }
    }
    handleDataFinance();
  }, [axiosPrivate]);

  //1/ Number Of Lessons (stats endpoint — chart by academic year)
  useEffect(() => {
    async function handleDataLeson() {
      try {
        const response = await axiosPrivate.get(`${baseURL}/${LESSONS}/`);
        console.log("Lessons Stats:", response.data);
        const lessonData = response.data?.topAcademicYears || [];
        setDataLesson(Array.isArray(lessonData) ? lessonData : []);
        setTotalLessons(response.data?.totalLessons ?? 0);
      } catch (err) {
        console.error("Error fetching lessons data:", err);
      }
    }
    handleDataLeson();
  }, [axiosPrivate, refreshKey]);

  //1/ handel Message
  useEffect(() => {
    async function handelMessage() {
      try {
        const response = await axiosPrivate.post(
          `${baseURL}/${STUDENTQUEREY}/`,
          { page: 1, limit: 10 }
        );
        console.log("Student Messages:", response.data);
        setMessages(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching student messages:", err);
      }
    }

    handelMessage();
  }, [axiosPrivate]);

  //1/ handel ContactMessage
  useEffect(() => {
    async function handelContactMessage() {
      try {
        const response = await axiosPrivate.post(
          `${baseURL}/${CONTACTMESSAGE}/`,
          { page: 1, limit: 10 }
        );
        console.log("Contact Messages:", response.data);
        setcontaMessage(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching contact messages:", err);
      }
    }
    handelContactMessage();
  }, [axiosPrivate]);

  //1/ handelTask
  useEffect(() => {
    async function handelTask() {
      try {
        const response = await axiosPrivate.get(
          `${baseURL}/${TASKS}/${currentMonth + 1}`
        );
        console.log("Tasks:", response.data);

        const tasksWithRemaining = (response.data?.data || []).map((task) => {
          const taskDate = new Date(task.task_date);
          const diffDays = Math.ceil(
            (taskDate - new Date()) / (1000 * 60 * 60 * 24)
          );

          return {
            ...task,
            days_remaining: diffDays > 0 ? diffDays : 0,
          };
        });

        setTask(tasksWithRemaining);
        setTotalTask(tasksWithRemaining.length);
      } catch (err) {
        console.error("Error fetching tasks:", err);
      }
    }

    handelTask();
  }, [axiosPrivate, currentMonth]);

  //1/ Fetch Academic Years
  useEffect(() => {
    async function fetchAcademicYears() {
      try {
        const response = await axiosPrivate.post(
          `${baseURL}/${ACADEMACYEARSDASHBORD}`,
          {}
        );
        console.log("Academic Years:", response.data);
        setTotalAcademicYears(response.data?.data?.length || 0);
      } catch (err) {
        console.error("Error fetching academic years:", err);
      }
    }
    fetchAcademicYears();
  }, [axiosPrivate]);

  //1/ Fetch Chapters
  useEffect(() => {
    async function fetchChapters() {
      try {
        const response = await axiosPrivate.post(`${baseURL}/${STYDYMONTH}/`, {
          Order: "chapterName",
          OrderType: false,
          TypeStudent: "-",
          post: false,
          indexpage: 1,
        });
        console.log("Chapters:", response.data);
        setTotalChapters(response.data?.data?.length || response.data?.totalPages || 0);
      } catch (err) {
        console.error("Error fetching chapters:", err);
      }
    }
    fetchChapters();
  }, [axiosPrivate]);

  //1/ Fetch Exams
  useEffect(() => {
    async function fetchExams() {
      try {
        const response = await axiosPrivate.post(`${baseURL}/${EXAMDASHBORD}`, {});
        console.log("Exams:", response.data);
        setTotalExams(
          response.data?.totalExams ?? response.data?.total_exams ??
            (Array.isArray(response.data?.data) ? response.data.data.length : 0)
        );
      } catch (err) {
        console.error("Error fetching exams:", err);
      }
    }
    fetchExams();
  }, [axiosPrivate]);

  //1/ Fetch Questions
  useEffect(() => {
    async function fetchQuestions() {
      try {
        const response = await axiosPrivate.post(
          `${baseURL}/${CREATEQUESTIONDASHBORD}`,
          {}
        );
        console.log("Questions:", response.data);
        setTotalQuestions(
          response.data?.totalQuestions ?? response.data?.total_questions ??
            (Array.isArray(response.data?.data) ? response.data.data.length : 0)
        );
      } catch (err) {
        console.error("Error fetching questions:", err);
      }
    }
    fetchQuestions();
  }, [axiosPrivate]);

  //1/ Fetch Announcements/Ads
  useEffect(() => {
    async function fetchAds() {
      try {
        const response = await axiosPrivate.post(`${baseURL}/${ANNOUNCEMNTS}`, {});
        console.log("Announcements:", response.data);
        setTotalAds(
          response.data?.totalAnnouncements ?? response.data?.total_announcements ??
            (Array.isArray(response.data?.data) ? response.data.data.length : 0)
        );
      } catch (err) {
        console.error("Error fetching announcements:", err);
      }
    }
    fetchAds();
  }, [axiosPrivate]);

  //1/ Fetch Students
  useEffect(() => {
    async function fetchStudents() {
      try {
        const response = await axiosPrivate.post(`${baseURL}/${USERDASHBORD}`, {
          indexpage: 1,
        });
        console.log("Students:", response.data);
        setTotalStudents(
          response.data?.total ?? response.data?.totalStudents ??
            (Array.isArray(response.data?.data) ? response.data.data.length : 0)
        );
      } catch (err) {
        console.error("Error fetching students:", err);
      }
    }
    fetchStudents();
  }, [axiosPrivate]);

  const [showModal, setShowModal] = useState(false);
  const [selectedMsg, setSelectedMsg] = useState(null);

  const formatText = (value, fallback = "-") => {
    if (value === null || value === undefined) return fallback;
    if (typeof value === "object") {
      if (value.content !== undefined && typeof value.content !== "object") return String(value.content);
      if (value.name !== undefined && typeof value.name !== "object") return String(value.name);
      if (value.message !== undefined && typeof value.message !== "object") return String(value.message);
      if (value.value !== undefined && typeof value.value !== "object") return String(value.value);
      return JSON.stringify(value);
    }
    return String(value);
  };

  const getTextFromItem = (item, keys, fallback = "-") => {
    for (const key of keys) {
      if (item?.[key] !== undefined && item?.[key] !== null) {
        return formatText(item[key], fallback);
      }
    }
    return fallback;
  };

  //1/ دالة الفتح
  const handleShowModal = (msg) => {
    setSelectedMsg(msg);
    setShowModal(true);
  };

  //1/ دالة الغلق
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMsg(null);
  };

  const [selectedContactMsg, setSelectedContactMsg] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);

  const handleShowContactModal = (msg) => {
    setSelectedContactMsg(msg);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSelectedContactMsg(null);
  };

  return (
    <>
      <Container fluid className="py-4 dashboard-home">
        <Row className="g-4">
          {/* إجمالي المستخدمين */}
          <Col xl={4} xs={12}>
            <Card className="shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="text-end flex-grow-1">
                    <h6 className="mb-0 text-muted">إجمالي المستخدمين</h6>
                  </div>
                  <div className="numberofuser d-flex align-items-center justify-content-center">
                    <FaUser className="icon-box" />
                  </div>
                </div>

                <h4 className="fw-bold text-end">{totaluser} طالب</h4>

                <div className="mt-3" style={{ width: "100%", height: 150 }}>
                  {console.log("User chart data:", userAcademec)}
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={userAcademec}>
                      <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                      <RechartTooltip
                        contentStyle={{ direction: "rtl" }}
                        formatter={(value, name) => [`${value} طالب`, name]}
                      />
                      <Bar
                        dataKey="user_count"
                        fill="#36A2EB"
                        radius={[8, 8, 0, 0]}
                        barSize={25}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الأرباح */}
          <Col xl={4} xs={12}>
            <Card className="shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="text-end flex-grow-1">
                    <h6 className="mb-0 text-muted">إجمالي الأرباح</h6>
                  </div>
                  <div className="numberofuser d-flex align-items-center justify-content-center">
                    <FaDollarSign className="icon-box" />
                  </div>
                </div>

                <h4 className="fw-bold text-end">{totalRevenue} جنيه مصري</h4>

                <div className="mt-3" style={{ width: "100%", height: 150 }}>
                  {console.log("Revenue chart data:", DataFinance.map((item) => ({
                    name: item.name,
                    revenue: parseFloat(item.revenue) || 0,
                  })))}
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={DataFinance.map((item) => ({
                      name: item.name,
                      revenue: parseFloat(item.revenue) || 0,
                    }))}>
                      <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                      <RechartTooltip
                        contentStyle={{ direction: "rtl" }}
                        formatter={(value, name) => [`${value} جنيه`, name]}
                      />
                      <Bar
                        dataKey="revenue"
                        fill="#8979FF"
                        radius={[8, 8, 0, 0]}
                        barSize={25}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الدروس */}
          <Col xl={4} xs={12}>
            <Card className="shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="text-end flex-grow-1">
                    <h6 className="mb-0 text-muted">إجمالي الدروس</h6>
                  </div>
                  <div className="numberofuser d-flex align-items-center justify-content-center">
                    <FaChartBar className="fs-4 " />
                  </div>
                </div>

                <h4 className="fw-bold text-end">{totalLessons} درس</h4>

                <div className="mt-3" style={{ width: "100%", height: 150 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      data={DataLesson.map((item) => ({
                        name: item.name,
                        lesson_count: item.lesson_count ?? 0,
                      }))}
                    >
                      <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                      <RechartTooltip
                        contentStyle={{ direction: "rtl" }}
                        formatter={(value) => [`${value} درس`, "الدروس"]}
                      />
                      <Bar
                        dataKey="lesson_count"
                        fill="#8979FF"
                        radius={[8, 8, 0, 0]}
                        barSize={25}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي السنوات الدراسية */}
          <Col xl={2} lg={3} md={4} xs={6}>
            <Card className="shadow-sm h-100 stat-card bg-white">
              <Card.Body className="text-center">
                <div className="numberofuser mx-auto mb-3" style={{ backgroundColor: "#fff", border: "2px solid #033a55" }}>
                  <FaCalendarAlt className="icon-box" style={{ color: "#033a55" }} />
                </div>
                <h5 className="small mb-2" style={{ color: "#033a55" }}>السنوات الدراسية</h5>
                <h3 className="fw-bold" style={{ color: "#033a55" }}>{totalAcademicYears}</h3>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الفصول */}
          <Col xl={2} lg={3} md={4} xs={6}>
            <Card className="shadow-sm h-100 stat-card bg-white">
              <Card.Body className="text-center">
                <div className="numberofuser mx-auto mb-3" style={{ backgroundColor: "#fff", border: "2px solid #033a55" }}>
                  <FaBook className="icon-box" style={{ color: "#033a55" }} />
                </div>
                <h5 className="small mb-2" style={{ color: "#033a55" }}>الفصول</h5>
                <h3 className="fw-bold" style={{ color: "#033a55" }}>{totalChapters}</h3>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الامتحانات */}
          <Col xl={2} lg={3} md={4} xs={6}>
            <Card className="shadow-sm h-100 stat-card bg-white">
              <Card.Body className="text-center">
                <div className="numberofuser mx-auto mb-3" style={{ backgroundColor: "#fff", border: "2px solid #033a55" }}>
                  <FaChartBar className="icon-box" style={{ color: "#033a55" }} />
                </div>
                <h5 className="small mb-2" style={{ color: "#033a55" }}>الامتحانات</h5>
                <h3 className="fw-bold" style={{ color: "#033a55" }}>{totalExams}</h3>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الأسئلة */}
          <Col xl={2} lg={3} md={4} xs={6}>
            <Card className="shadow-sm h-100 stat-card bg-white">
              <Card.Body className="text-center">
                <div className="numberofuser mx-auto mb-3" style={{ backgroundColor: "#fff", border: "2px solid #033a55" }}>
                  <FaRegCircleUser className="icon-box" style={{ color: "#033a55" }} />
                </div>
                <h5 className="small mb-2" style={{ color: "#033a55" }}>الأسئلة</h5>
                <h3 className="fw-bold" style={{ color: "#033a55" }}>{totalQuestions}</h3>
              </Card.Body>
            </Card>
          </Col>

          {/* إجمالي الإعلانات */}
          <Col xl={2} lg={3} md={4} xs={6}>
            <Card className="shadow-sm h-100 stat-card bg-white">
              <Card.Body className="text-center">
                <div className="numberofuser mx-auto mb-3" style={{ backgroundColor: "#fff", border: "2px solid #033a55" }}>
                  <FaBell className="icon-box" style={{ color: "#033a55" }} />
                </div>
                <h5 className="small mb-2" style={{ color: "#033a55" }}>الإعلانات</h5>
                <h3 className="fw-bold" style={{ color: "#033a55" }}>{totalAds}</h3>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4 mt-5">
          {/* المواعيد القادمة */}
          <Col xl={4} xs={12}>
            <Card className="p-3 shadow-sm" style={{ borderRadius: "1rem" }}>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="text-muted">المواعيد القادمة</div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="fw-bold fs-4">{totalTask} مواعيد</div>
                <div className="numberofuser">
                  <FontAwesomeIcon
                    className="fs-4 icon-box"
                    icon={faCalendarAlt}
                  />
                </div>
              </div>

              {(showAll ? Task : Task.slice(0, 1)).map((item, idx) => (
                <div key={idx} className="bg-light rounded p-3 mb-2">
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px" }}
                    >
                      <FaRegCircleUser size={18} />
                    </div>
                    <div className="ms-2 fw-bold">
                      {getTextFromItem(item, ["name", "title", "content"], "بدون عنوان")}
                    </div>
                  </div>
                  <div className="text-muted mb-1">الوصف</div>
                  <div className="text-truncate small text-muted">
                    {getTextFromItem(item, ["description", "content", "body"], "بدون وصف")}
                  </div>
                  <div className="small text-muted mt-2">
                    التاريخ: {getTextFromItem(item, ["task_date", "taskDate", "date"], "غير محدد")} ({item.days_remaining})
                  </div>
                </div>
              ))}
              {Task.length > 1 && (
                <div className="text-center">
                  <Button
                    style={{
                      backgroundColor: "var(--brand-200)",
                      color: "#FFFF",
                    }}
                    variant="outline-primary"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "إخفاء المهام" : "اقرأ المزيد"}
                  </Button>
                </div>
              )}

              <div className="d-flex justify-content-between align-items-center mb-2">
                <Button
                  variant="light"
                  className="p-1"
                  onClick={handlePrevMonth}
                >
                  <BiChevronLeft />
                </Button>
                <div className="fw-bold">
                  {getMonthName(currentMonth)} {currentYear}
                </div>
                <Button
                  variant="light"
                  className="p-1"
                  onClick={handleNextMonth}
                >
                  <BiChevronRight />
                </Button>
              </div>

              <div className="text-center mb-3">
                <Row style={{ fontSize: "10px" }} className="mb-2 text-muted">
                  {[
                    "الأحد",
                    "الإثنين",
                    "الثلاثاء",
                    "الأربعاء",
                    "الخميس",
                    "الجمعة",
                    "السبت",
                  ].map((day, index) => (
                    <Col key={index}>{day}</Col>
                  ))}
                </Row>

                {generateCalendarRows().map((week, rowIndex) => (
                  <Row key={rowIndex} className="mb-1">
                    {week.map((day, colIdx) => (
                      <Col key={colIdx}>
                        <div
                          className={`py-1 rounded ${
                            day && taskDays.includes(day)
                              ? " box-day text-white fw-bold"
                              : ""
                          }`}
                        >
                          {day || ""}
                        </div>
                      </Col>
                    ))}
                  </Row>
                ))}
              </div>
            </Card>
          </Col>

          {/* الرسائل الأخيرة */}
          <Col xl={8} xs={12}>
            <Card className="shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="text-end flex-grow-1">
                    <h6 className="mb-0 fs-3 fw-bold">الرسائل الأخيرة</h6>
                  </div>
                  <div className="numberofuser d-flex align-items-center justify-content-center">
                    <FontAwesomeIcon
                      className="icon-box fw-bold"
                      icon={faBell}
                    />
                  </div>
                </div>

                <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                  <Nav variant="pills" className="justify-content-start mb-3">
                    <Nav.Item>
                      <Nav.Link eventKey="students">استفسارات الطلاب</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="contact">رسائل التواصل</Nav.Link>
                    </Nav.Item> */}
                  </Nav>

                  <Tab.Content>
                    {/* استفسارات الطلاب */}
                    <Tab.Pane eventKey="students">
                      <Card className="shadow-sm">
                        <Card.Body>
                          <Table hover responsive className="text-end">
                            <thead>
                              <tr>
                                <th>الاسم</th>
                                <th>السنة الدراسية</th>
                                <th>الوحدة</th>
                                <th>الدرس</th>
                                <th>الرسالة</th>
                                <th>خيارات</th>
                              </tr>
                            </thead>
                            <tbody>
                              {messages.map((msg, idx) => (
                                <tr key={idx}>
                                      <td>
                                        <strong>
                                          {getTextFromItem(msg, ["student", "username", "name", "email"], "غير معروف")}
                                        </strong>
                                      </td>
                                      <td>{getTextFromItem(msg, ["academic_year", "academicYear"], "-")}</td>
                                      <td>{getTextFromItem(msg, ["chapter", "chapterName"], "-")}</td>
                                      <td>{getTextFromItem(msg, ["lesson", "lessonName"], "-")}</td>
                                  <td className="fs-6">
                                    {formatText(msg.message)
                                      .split(" ")
                                      .slice(0, 2)
                                      .join(" ")}
                                    ...
                                  </td>

                                  <td className="text-start">
                                    <BsThreeDotsVertical
                                      size={20}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleShowModal(msg)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/* رسائل التواصل */}
                    <Tab.Pane eventKey="contact">
                      <Card className="shadow-sm">
                        <Card.Body>
                          <Table hover responsive className="text-end">
                            <thead>
                              <tr>
                                <th>الاسم</th>
                                <th>رقم الهاتف</th>
                                <th>الإيميل</th>
                                <th>الرسالة</th>
                                <th>خيارات</th>
                              </tr>
                            </thead>
                            <tbody>
                              {contactMessage.map((msg, idx) => (
                                <tr key={idx}>
                                  <td>
                                    <strong>{msg.name}</strong>
                                  </td>
                                  <td>{msg.phone_number}</td>
                                  <td>{msg.email}</td>
                                  <td className="fs-6">
                                    {msg.message
                                      ?.split(" ")
                                      .slice(0, 3)
                                      .join(" ")}
                                    ...
                                  </td>
                                  <td className="text-start">
                                    <BsThreeDotsVertical
                                      size={20}
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleShowContactModal(msg)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal show={showModal} onHide={handleCloseModal} centered dir="ltr">
          <Modal.Header className="position-relative border-0">
            <Modal.Title className="fw-bold fs-5">تفاصيل الرسالة</Modal.Title>

            {/* زر إغلاق دائري أحمر */}
            <Button
              variant="danger"
              onClick={handleCloseModal}
              className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              ×
            </Button>
          </Modal.Header>

          <Modal.Body>
            {selectedMsg && (
              <div
                className="p-3 border rounded bg-light"
                style={{ lineHeight: "2", direction: "rtl" }}
              >
                <p>
                  <strong>
                    <FaUser size={20} className="me-2" /> الاسم:
                  </strong>{" "}
                  {getTextFromItem(selectedMsg, ["student", "username", "name", "email"], "غير معروف")}
                </p>

                <p>
                  <strong>
                    <FaBook size={20} className="me-2" /> الدرس:
                  </strong>{" "}
                  {getTextFromItem(selectedMsg, ["lesson", "lessonName"], "-")}
                </p>
                <p>
                  <strong>
                    <FaComments size={20} className="me-2" /> الرسالة:
                  </strong>
                </p>
                <div
                  className="border rounded p-3 bg-light"
                  style={{ whiteSpace: "pre-wrap", lineHeight: "1.8" }}
                >
                  {formatText(selectedMsg.message, "-")}
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={showContactModal}
          onHide={handleCloseContactModal}
          centered
          dir="ltr"
        >
          <Modal.Header className="position-relative border-0">
            <Modal.Title className="fw-bold fs-5">
              تفاصيل رسالة التواصل
            </Modal.Title>

            <Button
              variant="danger"
              onClick={handleCloseContactModal}
              className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              ×
            </Button>
          </Modal.Header>

          <Modal.Body>
            {selectedContactMsg && (
              <div
                className="p-3 border rounded bg-light"
                style={{ lineHeight: "2", direction: "rtl" }}
              >
                <p>
                  <strong>
                    <FaUser size={20} className="me-2" /> الاسم:
                  </strong>{" "}
                  {getTextFromItem(selectedContactMsg, ["name"], "غير معروف")}
                </p>
                <p>
                  <strong>
                    {" "}
                    <FaPhone size={20} className="me-2" /> رقم الهاتف:
                  </strong>{" "}
                  {getTextFromItem(selectedContactMsg, ["phone_number", "phone"], "-")}
                </p>
                <p>
                  <strong>
                    <FaEnvelope size={20} className="me-2" /> الإيميل:
                  </strong>{" "}
                  {getTextFromItem(selectedContactMsg, ["email"], "-")}
                </p>
                <p>
                  <strong>
                    <FaComments size={20} className="me-2" /> الرسالة:
                  </strong>
                </p>
                <div className="border rounded p-3 bg-white">
                  {formatText(selectedContactMsg.message, "-")}
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
}
